import { useEffect } from 'react';
import { setSeoOverride, type SeoOverride } from './seoStore';

/**
 * Lets a page (e.g. a news/blog detail page) provide per-page SEO metadata
 * once its content has loaded. The centralized head manager picks this up and
 * merges it on top of the route defaults. Cleared automatically on unmount.
 */
export function useSeoOverride(override: SeoOverride | null): void {
  const key = override ? JSON.stringify(override) : '';

  useEffect(() => {
    if (!override) return undefined;
    setSeoOverride(override);
    return () => setSeoOverride(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}